export default function Footer() {
  return (
    <footer className="mt-6 border-t border-[#6B1226]/10" data-testid="footer">
      <div className="app-container px-4 sm:px-8 pt-5 pb-8 text-center space-y-1">
        <p className="text-[0.65rem] text-[#78716C]">
          © {new Date().getFullYear()} Les Vins du Bistroquet
        </p>
        <p className="text-[0.65rem] text-[#78716C] italic">
          L'abus d'alcool est dangereux pour la santé. À consommer avec modération.
        </p>
      </div>
    </footer>
  );
}
